module.exports = __webpack_public_path__ + "media/bootstrap-icons/dice-2-8e2b9e21.svg";